/**
 * Settings Module
 */

import api from 'api-client'
import {
	languages,
	sidebarBackgroundImages,
	sidebarFilters,
	routerAnimations,
	themes,
	headerFilters
} from "./data"


const state = {
	isUserSettingsDialogVisible: false,
	darkMode: false,                                       // dark mode
	collapseSidebar: false,                                // mini sidevar
	rtlLayout: false,                                      // rtl layout
	backgroundImage: false,                                // enable sidebar background image
	horizontalLayoutSidebar: false,                        // horizontal layout sidebar
	languages,                                             // languages
	selectedLocale: languages[0],                          // selected locale
	sidebarBackgroundImages,                               // sidebar backgorund images
	selectedSidebarBgImage: sidebarBackgroundImages[0],    // selected sidebar background image
	sidebarFilters,                                        // sidebar filters
	sidebarSelectedFilter: sidebarFilters[0],              // selected sidebar filter
	routerAnimations,                                      // router animations
	selectedRouterAnimation: routerAnimations[0],          // selected router animation
	themes,                                                // themes
	selectedTheme: themes[0],                              // selected theme
	headerFilters,                                         // header filters
	activeHeaderFilter: headerFilters[1],                  // selected header filter
	mobileSearchForm: false,
	seasons: [],
	articleTypes: [],
	season: 1
}

// getters
const getters = {
	isUserSettingsDialogVisible: state => state.isUserSettingsDialogVisible,
	darkMode: state => {
		return state.darkMode;
	},
	collapseSidebar: state => {
		return state.collapseSidebar;
	},
	boxLayout: state => {
		return state.boxLayout;
	},
	rtlLayout: state => {
		return state.rtlLayout;
	},
	backgroundImage: state => {
		return state.backgroundImage;
	},
	selectedLocale: state => {
		return state.selectedLocale;
	},
	languages: state => {
		return state.languages;
	},
	sidebarBackgroundImages: state => {
		return state.sidebarBackgroundImages;
	},
	selectedSidebarBgImage: state => {
		return state.selectedSidebarBgImage;
	},
	sidebarFilters: state => {
		return state.sidebarFilters;
	},
	sidebarSelectedFilter: state => {
		return state.sidebarSelectedFilter;
	},
	selectedRouterAnimation: state => {
		return state.selectedRouterAnimation;
	},
	routerAnimations: state => {
		return state.routerAnimations;
	},
	themes: state => {
		return state.themes;
	},
	selectedTheme: state => {
		return state.selectedTheme;
	},
	headerFilters: state => {
		return state.headerFilters;
	},
	activeHeaderFilter: state => {
		return state.activeHeaderFilter;
	},
	horizontalLayoutSidebar: state => {
		return state.horizontalLayoutSidebar;
	},
	mobileSearchForm: state => {
		return state.mobileSearchForm;
	},
	seasons: state => {
		// sort seasons by year
		const items = [...state.seasons].sort((a, b) => {
			if (a.year < b.year) {
				return 1
			}
			if (a.year > b.year) {
				return -1
			}
			if (a.year === b.year) {
				return 0
			}
		})
		return items
	},
	season: state => {
		return state.season
	},
	articleTypes: state => {
		const items = [...state.articleTypes].sort((a, b) => {
			if (a.Name < b.Name) {
				return -1
			}
			if (a.Name > b.Name) {
				return 1
			}
			if (a.Name === b.Name) {
				return 0
			}
		})
		return items
	}

}

// actions
const actions = {
	togggleUserSettingsDialogVisible(context) {
		context.commit('isUserSettingsDialogVisible')
	},
	toggleDarkMode(context) {
		context.commit('darkMode')
	},
	collapseSidebar(context) {
		context.commit('collapseSidebarHandler');
	},
	boxLayout(context) {
		context.commit('boxLayoutHandler');
	},
	rtlLayout(context) {
		context.commit('rtlLayoutHandler');
	},
	backgroundImage(context) {
		context.commit('sidebarBgImageHandler');
	},
	changeLanguage(context, payload) {
		context.commit('changeLanguageHandler', payload);
	},
	changeBackgroundImage(context, payload) {
		context.commit('changeBackgroundImageHandler', payload);
	},
	changeSidebarFilter(context, payload) {
		context.commit('changeSidebarFilterHandler', payload);
	},
	changeRouterAnimation(context, payload) {
		context.commit('changeRouterAnimationHandler', payload);
	},
	changeTheme(context, payload) {
		context.commit('changeThemeHandler', payload);
	},
	changeHeaderFilter(context, payload) {
		context.commit('changeHeaderFilterHandler', payload);
	},
	setMiniSidebarLayout(context, payload) {
		context.commit('setMiniSidebarLayoutHandler', payload);
	},
	toggleHorizontalLayoutSidebar(context, payload) {
		context.commit('toggleHorizontalLayoutSidebarHandler', payload);
	},
	toggleSearchForm(context) {
		context.commit('toggleSearchFormHandler');
	},
	getSeasons(context) {
		return api.findSeasons({})
			.then(result => context.commit('setSeasons', result))
	},
	getArticleTypes(context) {
		return api.findArticleTypes()
			.then(result => context.commit('articleTypes', result))
	},
	setSeason({ commit, dispatch, state }, params) {
		commit('season', params.seasonId)
		dispatch('loadReportingData', params.seasonId)
			.then(() => {
				const currentSeason = state.seasons.find(season => season.id === params.seasonId)
				const lastSeason = state.seasons.find(season => season.year === (currentSeason.year - 1))
				if (lastSeason) {
					dispatch('loadReportingDataLastSeason', lastSeason.id)
				}
			})
		if (params.companyId > 0) {
			dispatch('getGuestDetailsEvents', { companyId: params.companyId, seasonId: params.seasonId })
		}
		// dispatch('setUserSeason', seasonId)
	},
	setUserSeason(context, seasonId) {
		return api.saveUserSeason(seasonId)
	}
}

// mutations
const mutations = {
	isUserSettingsDialogVisible(state) {
		state.isUserSettingsDialogVisible = !state.isUserSettingsDialogVisible
	},
	darkMode(state) {
		state.darkMode = !state.darkMode;
	},
	collapseSidebarHandler(state) {
		state.collapseSidebar = !state.collapseSidebar;
	},
	boxLayoutHandler(state) {
		state.boxLayout = !state.boxLayout;
	},
	rtlLayoutHandler(state) {
		state.rtlLayout = !state.rtlLayout;
	},
	sidebarBgImageHandler(state) {
		state.backgroundImage = !state.backgroundImage;
	},
	changeLanguageHandler(state, language) {
		state.selectedLocale = language;
		if (language.locale === 'he' || language.locale === 'ar') {
			state.rtlLayout = true;
		} else {
			state.rtlLayout = false;
		}
	},
	changeBackgroundImageHandler(state, image) {
		state.selectedSidebarBgImage = image;
	},
	changeSidebarFilterHandler(state, filter) {
		state.sidebarSelectedFilter = filter;
	},
	changeRouterAnimationHandler(state, animation) {
		state.selectedRouterAnimation = animation;
	},
	changeThemeHandler(state, theme) {
		state.selectedTheme = theme;
	},
	changeHeaderFilterHandler(state, filter) {
		state.activeHeaderFilter = filter;
	},
	setMiniSidebarLayoutHandler(state, isSet) {
		state.collapseSidebar = isSet;
	},
	toggleHorizontalLayoutSidebarHandler(state, value) {
		state.horizontalLayoutSidebar = value;
	},
	toggleSearchFormHandler(state) {
		state.mobileSearchForm = !state.mobileSearchForm;
	},
	setSeasons(state, seasons) {
		state.seasons = seasons
	},
	season(state, season) {
		state.season = season
	},
	articleTypes(state, articleTypes) {
		state.articleTypes = articleTypes
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}
